//#region Imports
import React, { useState, useEffect } from "react";
import {
    StyleSheet,
    SectionList,
    SafeAreaView,
    ActivityIndicator,
    Text,
    TouchableOpacity
} from "react-native";
import CustomLabel from "../../../../components/CustomLabel/CustomLabel";
import { useReports } from "../../../../hooks/useReports";
import { useTranslation } from "react-i18next";
import { useTheme } from "@react-navigation/native";

const MonitorsScreen = ({ route }) => {
    const { getMonitors, isLoading } = useReports();
    const [monitors, setMonitors] = useState([]);
    const { colors } = useTheme();
    const styles = makeStyles(colors);
    const { t } = useTranslation();
    const [expandedSections, setExpandedSections] = useState(new Set());
    // * Transform Data to Section List 

    useEffect(() => {
        getMonitors().then((resp) => {
            const sections = Object.values(
                resp.reduce((acc, item) => {
                    const key = item.monitor; // Group by monitor instead of name
                    if (!acc[key]) {
                        acc[key] = { title: key, data: [] };
                    }
                    acc[key].data.push(item);
                    return acc;
                }, {})
            );
            setMonitors(sections);
        }).catch((error) => {
            console.log(error)
        })
    }, [])


    const toggleSection = (title) => {
        const newExpanded = new Set(expandedSections);
        if (newExpanded.has(title)) {
            newExpanded.delete(title);
        } else {
            newExpanded.add(title);
        }
        setExpandedSections(newExpanded);
    };

    const renderSectionHeader = ({ section: { title } }) => (
        <TouchableOpacity
            style={styles.header}
            onPress={() => toggleSection(title)}
            activeOpacity={0.7}
        >
            <SafeAreaView style={styles.headerContent}>
                <CustomLabel value={title} type="REP" />
                <Text style={[
                    styles.expandIcon,
                    { transform: [{ rotate: expandedSections.has(title) ? '90deg' : '0deg' }] }
                ]}>
                    ›
                </Text>
            </SafeAreaView>
        </TouchableOpacity>
    );

    const renderItem = ({ item, section }) => (
        expandedSections.has(section.title) && (
            <SafeAreaView style={styles.item}>
                <CustomLabel value={`${item?.name} - ${item?.id}`} type="REP" />
            </SafeAreaView>
        )
    );

    if (isLoading) {
        return (
            <SafeAreaView
                style={styles.main}>
                <ActivityIndicator animating={true} size='large' color="#86BC25" />
            </SafeAreaView>
        )
    }
    return (
        <SafeAreaView style={styles.main}>
            <SectionList
                sections={monitors}
                keyExtractor={(item) => `${item.id}-${item.monitor}`}
                renderItem={renderItem}
                renderSectionHeader={renderSectionHeader}
                stickySectionHeadersEnabled
                ItemSeparatorComponent={() => !expandedSections.has(monitors.title) ? null : <SafeAreaView style={styles.separator} />}
                SectionSeparatorComponent={() => <SafeAreaView style={styles.sectionSeparator} />}
                ListEmptyComponent={
                    <SafeAreaView style={styles.emptyContainer}>
                        <CustomLabel value='No monitors found' type="REP" />
                    </SafeAreaView>
                }
            />
        </SafeAreaView >
    )
}
const makeStyles = (colors) =>
    StyleSheet.create({
        main: {
            flex: 1,
            marginTop: 20,
        },
        emptyContainer: {
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
            padding: 20,
        },
        // SectionList Components
        header: {
            backgroundColor: '#f5f5f5',
            paddingVertical: 12,
            paddingHorizontal: 16,
            borderBottomWidth: 1,
            borderBottomColor: colors.buttons_submit,
        },
        headerText: {
            fontSize: 18,
            fontWeight: 'bold',
            color: '#333',
        },
        item: {
            padding: 16,
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
        },
        name: {
            fontSize: 16,
            flex: 1,
        },
        primary: {
            fontSize: 14,
            color: '#666',
            marginLeft: 8,
        },
        separator: {
            height: 1,
            backgroundColor: '#eee',
        },
        sectionSeparator: {
            height: 2,
            backgroundColor: colors.buttons_submit,
        },
        header: {
            backgroundColor: '#f5f5f5',
            paddingVertical: 16,
            paddingHorizontal: 16,
            borderBottomWidth: 1,
            borderBottomColor: '#e0e0e0',
        },
        headerContent: {
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
        },
        headerText: {
            fontSize: 18,
            fontWeight: 'bold',
            color: '#333',
            flex: 1,
        },
        expandIcon: {
            fontSize: 20,
            fontWeight: 'bold',
            color: '#666',
            marginLeft: 12,
            transition: 'transform 0.2s ease',
        },
        sectionCount: {
            fontSize: 14,
            color: '#888',
            marginTop: 2,
        },
    });

export default MonitorsScreen;
//#endregion
